import * as React from 'react';
import { SVGProps,FC } from 'react';

const PartnerTransactionSidebar: FC<SVGProps<SVGSVGElement>> = (props): JSX.Element => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || 22}
      height={props.height || 22}
      viewBox="0 0 32 28"
      fill="none"
      className={`dynamic-icon ${props.className}`}
      {...props}
    >
      <path
        d="M3 13.8C3 10.123 3 8.28456 4.14228 7.14228C5.28456 6 7.12303 6 10.8 6H17.3C20.9769 6 22.8154 6 23.9577 7.14228C25.0999 8.28456 25.0999 10.123 25.0999 13.8C25.0999 17.4769 25.0999 19.3154 23.9577 20.4577C22.8154 21.5999 20.9769 21.5999 17.3 21.5999H10.8C7.12303 21.5999 5.28456 21.5999 4.14228 20.4577C3 19.3154 3 17.4769 3 13.8Z"
        stroke="#282C44"
        strokeWidth="2"
      />
      <path
        d="M25.1 9.99902C26.3676 10.1237 27.2209 10.4055 27.8577 11.0423C29 12.1846 29 14.0231 29 17.7C29 21.377 29 23.2155 27.8577 24.3577C26.7154 25.5 24.877 25.5 21.2 25.5H14.7C11.0231 25.5 9.18463 25.5 8.04235 24.3577C7.40549 23.7209 7.1237 22.8676 6.99902 21.6"
        stroke="#282C44"
        strokeWidth="2"
      />
      <path
        d="M17.2988 13.7988C17.2988 15.5937 15.8437 17.0488 14.0488 17.0488C12.2539 17.0488 10.7988 15.5937 10.7988 13.7988C10.7988 12.0039 12.2539 10.5488 14.0488 10.5488C15.8437 10.5488 17.2988 12.0039 17.2988 13.7988Z"
        stroke="#282C44"
        strokeWidth="2"
      />
      <path
        d="M21.2012 16.3994L21.2012 11.1994"
        stroke="#282C44"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M6.89941 16.3994L6.89941 11.1994"
        stroke="#282C44"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
export default PartnerTransactionSidebar;

